import { render } from "./AddEditBlackList.vue?vue&type=template&id=06abaf50&scoped=true"
import script from "./AddEditBlackList.vue?vue&type=script&lang=js"
export * from "./AddEditBlackList.vue?vue&type=script&lang=js"

import "./AddEditBlackList.vue?vue&type=style&index=0&id=06abaf50&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06abaf50"]])

export default __exports__